module.exports = __webpack_public_path__ + "media/bootstrap-icons/lamp-ff96cadc.svg";